<template>
  <div class="form__group">
    <div v-if="mediaIsImage">
      <img
        v-if="fileReceived && !loading"
        :src="attachment"
        alt=""
        class="img-thumbnail profile-image"
      />
      <img
        v-if="fileReceived && loading"
        class="bar-loader"
        src="../../../../../assets/svg_icons/loading_bars.svg"
      />
    </div>
    <div v-if="mediaIsFile">
      <iframe
        :src="
          'https://docs.google.com/viewer?url=' + attachment + '&embedded=true'
        "
        height="800px"
        width="600px"
      ></iframe>
      <img
        v-if="fileReceived && loading"
        class="bar-loader"
        src="../../../../../assets/svg_icons/loading_bars.svg"
      />
    </div>
    <div v-if="!fileReceived" class="form-group files">
      <input
        class="form-control-file"
        style="opacity: 0;"
        title=""
        type="file"
        @change="uploadFile()"
      />
    </div>
    <span class="reset-select" @click="removeFile()" v-if="fileReceived"
      ><i class="fas fa-times"></i
    ></span>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "UploadFileInput",
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    maxSizeMb: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      attachment: "",
      fileReceived: false,
      loading: false,
      mediaIsImage: false,
      mediaIsFile: false
    };
  },
  methods: {
    removeFile() {
      this.attachment = "";
      this.mediaIsImage = false;
      this.mediaIsFile = false;
      this.fileReceived = false;
    },
    uploadFile() {
      this.loading = true;
      this.fileReceived = true;
      if ($("input[type=file]")[0].files[0]["type"].split("/")[0] === "image") {
        this.mediaIsImage = true;
        this.mediaIsFile = false;
      } else {
        this.mediaIsFile = true;
        this.mediaIsImage = false;
      }

      let formData = new FormData();
      formData.append("attachment", $("input[type=file]")[0].files[0]);

      if (($("input[type=file]")[0].files[0].size/1000024) <= this.maxSizeMb) {
        apiClientCreator(`projects/contacts/add_file`)
          .post("", formData)
          .then(result => {
            if (!this.editMode) {
              this.attachment = result.data;
            }
            if (this.editMode) {
              this.attachment = result.data;
            }
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    }
  },
  watch: {
    attachment() {
      this.$emit("selectImage", this.attachment);
    }
  }
};
</script>

<style scoped lang="scss">
$bgColor: #009788;
$borderColor: #01756a;
.form__group {
  position: relative;
  padding: 15px 0 0;
  margin-top: 10px;
}
.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #d2d2d2;
  outline: 0;
  font-size: 16px;
  color: #212121;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;
}

.form__field::placeholder {
  color: transparent;
}

.form__field:placeholder-shown ~ .form__label {
  font-size: 16px;
  cursor: text;
  top: 20px;
}

label,
.form__field:focus ~ .form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 12px;
  color: #9b9b9b;
}

.form__field:focus ~ .form__label {
  color: $bgColor;
}
.form__field:focus ~ .input-icon {
  color: $bgColor;
}

.form__field:focus {
  padding-bottom: 6px;
  border-bottom: 2px solid $bgColor;
}
/*Inputs custom style ends ############################################################# */
.modal-content {
  padding: 5%;
}
.input-icon {
  position: absolute;
  left: -30px;
  top: 25px;
  font-size: 1.9rem;
}
.countryList-container {
  max-height: 250px;
  //min-height: 100px;
  overflow-y: auto;
  position: absolute;
  background-color: white;
  width: 100%;
  z-index: 1;
}

/*Scroll custom style starts ############################################################# */

.countryList-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.countryList-container::-webkit-scrollbar {
  width: 7px;
  background-color: $bgColor;
  /*display: none;*/
}

.countryList-container::-webkit-scrollbar-thumb {
  background-color: $bgColor;
  border: 2px solid $borderColor;
  border-radius: 5px;
}
/*Scroll custom style ends ############################################################# */

.country-item {
  color: $bgColor;
  transition: all 0.2ms ease-in-out;
}
.country-item:hover {
  background-color: #ebebeb;
  cursor: pointer;
}
.reset-select {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 16%;
}
.reset-select:hover {
  color: grey;
}

.files {
  position: relative;
  outline: 2px dashed #92b0b3;
  outline-offset: -10px;
  width: 100px;
  height: 100px;
}

.files:before {
  position: absolute;
  content: "CLICK OR DRAG & DROP";
  left: 0;
  pointer-events: none;
  width: 100%;
  right: 0;
  //height: 100%;
  display: block;
  margin: 0 auto;
  color: #2ea591;
  font-weight: 600;
  text-transform: capitalize;
  text-align: center;
  font-size: 14px;
  top: 18px;
}
input[type="file"] {
  display: block;
  height: 100%;
  width: 100%;
  cursor: pointer;
}
.profile-image {
  border-radius: 20%;
  height: 80px;
  width: 80px;
}
.bar-loader {
  position: absolute;
  left: 20px;
  top: 10px;
  height: 50px;
}
</style>
